export const environment = {
  production: false,
  apiUrl: 'https://backend.maessa.noro.dev/api/v1',
  jwtRefreshUrl: 'https://backend.maessa.noro.dev/api/v1/token/refresh',
};
